/**
 * imports
 */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './scss/collection/main.scss'

import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select"
import VueLazyload from 'vue-lazyload'
import Flickity from 'vue-flickity'
import MobileFooterNavigation from "./vue/components/mobile-footer-navigation"
import VideoPlay from './vue/components/video-play'
import ProductQuickView from './vue/components/product-quick-view'
/**
 * create vue instance function
 */
const createVueApp = () => {
  const app = createApp({})
  const pinia = createPinia()

  app.use(VueLazyload, {
    preLoad: 1,
    observer: true,
    observerOptions: {
      rootMargin: '0px',
      threshold: 0.1
    }
  })
  app.use(VueAxios, axios)
  app.component("VSelect", vSelect)
  app.component('VueFlickity', Flickity)
  app.component("MobileFooterNavigation", MobileFooterNavigation)
  app.component('VideoPlay', VideoPlay)
  app.component('ProductQuickView', ProductQuickView)
  /**
   * vue components
   * auto-import all vue components
   */
  const vueComponents = require.context('./vue/components-collection/', true, /\.(vue|js)$/)

  vueComponents.keys().forEach(key => {
    const component = vueComponents(key).default

    // if a component has a name defined use the name, else use the path as the component name
    const name = component.name
      ? component.name
      : key.replace(/\.(\/|vue|js)/g, '').replace(/(\/|-|_|\s)\w/g, (match) => match.slice(1).toUpperCase())

    app.component(name, component)
  })


  /**
   * vue plugins
   * extend with additional features
   */
  app.use(pinia)

  return app
}

/**
 * create and mount vue instance(s)
 */
const appElement = document.querySelector('#MainContent')

if (appElement) {
  createVueApp().mount(appElement)
} else {
  const vueElements = document.querySelectorAll('[vue]')
  if (vueElements) vueElements.forEach(el => createVueApp().mount(el))
}

/**
 * fixes for Shopify sections
 * 1. properly render vue components on user insert in the theme editor
 * 2. reload the current page to rerender async inserted sections with vue components
 *
 * add the 'vue' keyword to the section's wrapper classes if the section uses any vue functionality e.g.:
 * {% schema %}
 * {
 *   "class": "vue-section"
 * }
 * {% endschema %}
 */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      createVueApp().mount(event.target)
    }
  })
} else if (!Shopify.designMode && process.env.NODE_ENV === 'development') {
  new MutationObserver((mutationsList) => {
    mutationsList.forEach(record => {
      const vue = Array.from(record.addedNodes).find(node => node.classList && node.classList.value.includes('vue'))
      if (vue) window.location.reload()
    })
  }).observe(document.body, {
    childList: true,
    subtree: true
  })
}
